export default "__VITE_ASSET__CsR8GWyj__"